import { createRouter, createWebHistory } from 'vue-router';
import mainCard from '../components/mainCard.vue';
import projectCard from '../components/projectCard.vue';
import research from '../components/research.vue';
import InternshipCard from '../components/InternshipCard.vue';
import ClassesCard from '../components/ClassesCard.vue';

const routes = [
  { path: '/', name: 'Clyde\'s website', component: mainCard, meta: {title: 'Clyde Villacrusis — Developer & Researcher'} },
  { path: '/projects', component: projectCard, meta: { title: 'Projects — Clyde Villacrusis' } },
  { path: '/research', component: research, meta: { title: 'Research — Clyde Villacrusis' } },
  {
    path: '/interests',
    name: 'interests',
    component: () => import('../views/InterestsView.vue'),
    meta: { title: 'Interests — Clyde Villacrusis' }
  },
  {
    path: '/checkers',
    name: 'checkers',
    component: () => import('../components/checkersPage.vue'),
    meta: { title: 'AI Checkers — Clyde Villacrusis' }
  },
  {
    path: '/internships',
    name: 'Internships',
    component: InternshipCard,
    meta: { title: 'Experience — Clyde Villacrusis' }
  },
  {
    path: '/classes',
    name: 'Classes',
    component: ClassesCard,
    meta: { title: 'Courses — Clyde Villacrusis' }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Clyde\'s website';
  next();
});

export default router;
